import { render, staticRenderFns } from "./IndicatorRelationshipPopup.vue?vue&type=template&id=377a3959"
import script from "./IndicatorRelationshipPopup.vue?vue&type=script&lang=js"
export * from "./IndicatorRelationshipPopup.vue?vue&type=script&lang=js"
import style0 from "./IndicatorRelationshipPopup.vue?vue&type=style&index=0&id=377a3959&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports